module.exports = __webpack_public_path__ + "img/stt-dex-active.2b1ac42b.svg";